import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import useRestApiClient from 'src/hooks/useRestApiClient';

const initialState = {
  industries: []
};

const IndustriesContext = createContext(initialState);

export const IndustriesProvider = (props) => {
  const { children } = props;
  const [industries, setIndustries] = useState(initialState.industries);
  const client = useRestApiClient();

  const loadIndustries = async () => {
    try {
      const {
        data: { message }
      } = await client.get('/industries');
      setIndustries(message);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <IndustriesContext.Provider
      value={{
        industries,
        loadIndustries
      }}
      {...props}
    >
      {children}
    </IndustriesContext.Provider>
  );
};

IndustriesProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default IndustriesContext;
